export const endPoints = {
  empSub: '/subcontractor',
  agency: '/agency',
  prospectAgency: '/prospects/agency',
  breakdownPayrollAgency: '/breakdown-payrolls/agencies',
  userAdmin: '/users/admin',
  vatCode: '/vat-code',
  paymentRate: '/payment-rate',
  assignment: '/assignment',
  timeSheet: '/time-sheet',
  bank: '/bank-name',
  agencyUsers: '/agency/contact',
  company: '/company',
  breakdownPayrollCompany: '/breakdown-payrolls/companies',
  assignmentInSub: '/subcontractor/assignments',
  agencyRelationSubcontractorByTimeSheet: '/subcontractor/time-sheets',
  agencyAssignToSub: '/subcontractor/agency-list',
  listSubcontractorByPrimary: '/agency/subcontractors',
  companyBySub: '/subcontractor/company-list',
  expenseGroup: '/expenses-company/group',
  expenseList: '/company',
  companiesTimesheets: '/time-sheet/companies-timesheet',
  agenciesTimesheets: '/v2/time-sheet/agencies-timesheet',
  draftPayrollCompanies: '/draft-payroll/companies',
  draftPayrollAgencies: '/v2/draft-payroll/agencies',
  siteId: '/agency/site',
  empSubV2: '/v2/subcontractor/search',
  userGroup: '/user-groups',
  userAdminCompany: '/users/admin-company',
  employer: '/users/employers',
  userList: '/users/all/users-list',
  permissionEmployers: '/permissions/employers',
};
